// tslint:disable:max-line-length
import { Component, OnInit, Input, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { WorkItemModel } from '../../models/work-item';
import { BehaviorSubject } from 'rxjs';
import { UIMenuModel } from 'e5core-angular-services';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-menu',
  template: `
    <span [ngSwitch]="style.current()">
      <e5core-ui-work-menu-box       *ngSwitchCase='0' [workItem$]='workItem$' [menuItems]='menuItems'></e5core-ui-work-menu-box>
      <e5core-ui-work-menu-bootstrap *ngSwitchCase='1' [workItem$]='workItem$' [menuItems]='menuItems'></e5core-ui-work-menu-bootstrap>
      <e5core-ui-work-menu-material  *ngSwitchCase='2' [workItem$]='workItem$' [menuItems]='menuItems'></e5core-ui-work-menu-material>
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class E5coreUiWorkMenuComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  workItemModel: WorkItemModel;
  menuItems: UIMenuModel[] ;

  constructor(public style:UiStyleService, private cd: ChangeDetectorRef ) { }

  ngOnInit() {
    if (this.workItem$ == null) {
      console.error('e5core-ui-work-menu [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }
    this.workItem$.subscribe(
      wi => {
        this.workItemModel = wi ;
        this.menuItems = [] ;
        if (this.workItemModel && this.workItemModel.menus) {
          this.menuItems = this.workItemModel.menus ;
        }
        this.cd.markForCheck() ;
      },
      e => this.menuItems = null
    );
  }

}
